import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import GenericModal from "./GenericModal";
import ModalUpdateSuccess from "./ModalUpdateSuccess";
import { updateVendorUser } from "./redux/slices/authThunks";
import { OutlineEye, OutlineEyeOff } from "./assets";
import { useNavigate } from "react-router-dom";

export default function Profilepasswordone({ setActiveItem }) {
  const dispatch = useDispatch();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setshowPassword] = useState(false);
  const [showNewpass, setshowNewpass] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

    if (!password) {
      return { valid: false, message: "New password is required" };
    }

    if (!regex.test(password)) {
      return {
        valid: false,
        message:
          "Password must be at least 8 characters with a mix of letters & numbers.",
      };
    }

    return { valid: true };
  };
  const handleSubmit = async () => {
    // Reset errors
    setOldPasswordError("");
    setNewPasswordError("");
    setPasswordError("");

    let hasError = false;

    // Validate old password
    if (!oldPassword) {
      setOldPasswordError("Old password is required");
      hasError = true;
    }

    // Validate new password
    const validation = validatePassword(newPassword);
    if (!validation.valid) {
      setNewPasswordError(validation.message);
      hasError = true;
    } else if (oldPassword && newPassword === oldPassword) {
      setNewPasswordError(
        "New password must be different from the old password"
      );
      hasError = true;
    }

    if (hasError) return;

    // Get user from localStorage
    const vendor = JSON.parse(localStorage.getItem("user") || "{}");
    if (!vendor?._id) {
      setPasswordError("User session has expired. Please log in again.");
      return;
    }

    const payload = {
      _id: vendor._id,
      oldPassword,
      newPassword,
    };

    setIsLoading(true);
    try {
      await dispatch(updateVendorUser(payload)).unwrap();
      setOldPassword("");
      setNewPassword("");
      openModal();
    } catch (error) {
      // Handle API error message
      if (typeof error === "string") {
        setPasswordError(error);
      } else if (error?.message) {
        setPasswordError(error.message);
      } else {
        setPasswordError("Failed to update password. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Frame1501>
      <Frame1496>
        <ChangePassword>Change Password</ChangePassword>
        <Frame1502>
          <PRTNR.Input
            label="Old Password"
            type={showPassword ? "text" : "password"}
            icon={showPassword ? OutlineEye : OutlineEyeOff}
            onIconClick={() => setshowPassword(!showPassword)}
            value={oldPassword}
            error={!!oldPasswordError}
            errorMessage={oldPasswordError}
            onChange={(e) => {
              setOldPassword(e.target.value);
              if (oldPasswordError) setOldPasswordError("");
              if (passwordError) setPasswordError("");
            }}
            disabled={isLoading}
          />
        </Frame1502>
        <Frame1502>
          <PRTNR.Input
            label="New Password"
            value={newPassword}
            type={showNewpass ? "text" : "password"}
            icon={showNewpass ? OutlineEye : OutlineEyeOff}
            onIconClick={() => setshowNewpass(!showNewpass)}
            onChange={(e) => {
              setNewPassword(e.target.value);
              if (newPasswordError) setNewPasswordError("");
              if (passwordError) setPasswordError("");
            }}
            error={!!newPasswordError}
            errorMessage={newPasswordError}
            required
            disabled={isLoading}
          />
        </Frame1502>
        {passwordError && <ErrorMessage>{passwordError}</ErrorMessage>}
        <PasswordRequirement>
          Password must be at least 8 characters with a mix of letters &
          numbers.
        </PasswordRequirement>
      </Frame1496>
      <Frame1500>
        <PRTNR.Button
          onClick={() => {
            setOldPassword("");
            setNewPassword("");
            setActiveItem("sectors");
          }}
          variant="gray-light"
          disabled={isLoading}
        >
          Cancel
        </PRTNR.Button>

        <Frame1399>
          <PRTNR.Button
            variant="black"
            onClick={handleSubmit}
            disabled={isLoading}
            loading={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </PRTNR.Button>
        </Frame1399>
      </Frame1500>
      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalUpdateSuccess isOpen={isModalOpen} onClose={closeModal} />
      </GenericModal>
    </Frame1501>
  );
}

const Frame1502 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1501 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  gap: 21px;
  width: 886px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1496 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const ChangePassword = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const Frame5_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 4px;
  width: 738px;
  box-sizing: border-box;
`;

const PasswordRequirement = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  margin-top: 4px;
`;

const Frame1500 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 17px;
  box-sizing: border-box;

  @media (max-width: 640px) {
    flex-direction: column;
    width: 100%;
  }
`;

const Frame1399 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
  width: 250px;
  @media (max-width: 640px) {
    width: 100%;
  }
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  text-align: left;
  display: block;
`;
